import React, { useContext, useEffect, useMemo } from 'react'

import AgencyConfirmation from '../AgencyConfirmation'
import SubmissionForm from './SubmissionForm'
import { DataContext } from '../DataContext'
import LoadingWrapper from '../../../wrappers/LoadingWrapper'

export default () => {
    const { activeAgency, createUpload, isForminProgress, formType } = useContext(DataContext)

    const isWellMerge = useMemo(() =>
        formType && formType.FormType === 'WellMerge', [formType])

    useEffect(() => {
        if (isWellMerge && !isForminProgress) {
            createUpload('NDEE')
        }
    }, [isWellMerge, isForminProgress])

    return isForminProgress || isWellMerge ?
        <LoadingWrapper data={activeAgency} >
            <SubmissionForm />
        </LoadingWrapper>
            :
        <AgencyConfirmation onSubmit={ createUpload } />
}
